var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M21 16.477v2.71a1.8 1.8 0 0 1-1.23 1.718c-.24.08-.492.11-.744.088a17.9 17.9 0 0 1-7.81-2.773 17.6 17.6 0 0 1-5.43-5.42 17.85 17.85 0 0 1-2.779-7.83A1.8 1.8 0 0 1 4.08 3.153c.23-.101.478-.154.73-.154h2.714a1.81 1.81 0 0 1 1.81 1.554c.115.867.328 1.718.634 2.538a1.8 1.8 0 0 1-.407 1.906l-1.15 1.147a14.47 14.47 0 0 0 5.43 5.42l1.15-1.148a1.81 1.81 0 0 1 1.91-.406c.82.305 1.674.518 2.543.632a1.81 1.81 0 0 1 1.556 1.834",
  vectorEffect: "non-scaling-stroke"
})));
export default SvgPhone;